import { History } from 'history';
import { JobberStatus } from '../common/CommonInterfaces';
import { UserType } from '../remoteExecution/RemoteExecutionServiceImpl';
import { IsAgencyUser, IsOrgPortalUser } from '../shared-components/shared-utils/UserPermissionsUtils';
import { WORKY_WEB_APP_PATHS } from '../WorkyWebAppPaths';

const resolvePostLoginPath = ({
    userType,
}: {
    userType: UserType | string;
}): string => {
    if (IsAgencyUser({ userType })) {
        return WORKY_WEB_APP_PATHS.myShifts;
    }
    if (IsOrgPortalUser({ userType })) {
        return WORKY_WEB_APP_PATHS.endClientMyShifts;
    }
    return WORKY_WEB_APP_PATHS.homepage;
};

const navigateAfterSignIn = ({
    history,
    userType,
}: {
    history: History;
    userType: UserType | string;
    jobberStatus?: JobberStatus | null;
}): void => {
    const destinationPath: string = resolvePostLoginPath({ userType });
    history.push(destinationPath);
};

export { navigateAfterSignIn, resolvePostLoginPath };
